import api from ".";
import { getToken } from "../Auth/Token";

// Common headers
const getHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

// ================= GET ALL =================
export const getRMRows = async () => {
  try {
    const res = await api.get("/api/rm-database", {
      // /api/rm-database
      headers: getHeaders(),
    });

    return res.data.data || res.data;
  } catch (error) {
    console.log("Get RM Rows Error:", error);
    throw error;
  }
};

// ================= GET SINGLE =================
export const getRMRowById = async (id) => {
  try {
    const res = await api.get(`/api/rm-database/${id}`, {
      headers: getHeaders(),
    });

    return res.data.data || res.data;
  } catch (error) {
    console.log("Get RM Row Error:", error);
    throw error;
  }
};

// ================= CREATE =================
export const createRMRow = async (data) => {
  try {
    const res = await api.post("/api/rm-database", data, {
      headers: getHeaders(),
    });

    return res.data.data || res.data;
  } catch (error) {
    console.log("Create RM Row Error:", error);
    throw error;
  }
};

// ================= UPDATE =================
export const updateRMRow = async (id, data) => {
  try {
    const res = await api.put(`/api/rm-database/${id}`, data, {
      headers: getHeaders(),
    });

    return res.data.data || res.data;
  } catch (error) {
    console.log("Update RM Row Error:", error);
    throw error;
  }
};
// ================= BULK SAVE =================
export const bulkSaveRMRows = async (rows) => {
  try {
    const res = await api.put(
      "/api/rm-database/bulk",
      { rows },
      {
        headers: getHeaders(),
      }
    );

    return res.data.data || res.data;
  } catch (error) {
    console.log("Bulk Save Error:", error);
    throw error;
  }
};

// ================= DELETE =================
export const deleteRMRow = async (id) => {
  try {
    const res = await api.delete(`/api/rm-database/${id}`, {
      headers: getHeaders(),
    });

    return res.data.data || res.data;
  } catch (error) {
    console.log("Delete RM Row Error:", error);
    throw error;
  }
};